// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { ConfirmationResult, getAuth } from "firebase/auth";
import { getAnalytics } from "firebase/analytics";
import { EnvVariables } from "../enums/env.variables.enums";
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: EnvVariables.firebase.apiKey,
  authDomain: EnvVariables.firebase.authDomain,
  projectId: EnvVariables.firebase.projectId,
  storageBucket: EnvVariables.firebase.storageBucket,
  messagingSenderId: EnvVariables.firebase.messagingSenderId,
  appId: EnvVariables.firebase.appId,
  measurementId: EnvVariables.firebase.measurementId,
};

const firebaseApp = initializeApp(firebaseConfig);

let phoneConfirmationResult: ConfirmationResult | null = null;

export class FirebaseServices {
  static setPhoneConfirmationResult = (
    confirmationResult: ConfirmationResult
  ) => {
    phoneConfirmationResult = confirmationResult;
  };

  static getPhoneConfirmationResult = () => {
    return phoneConfirmationResult;
  };

  static removeConfirmationResult = () => {
    phoneConfirmationResult = null;
  };

  static firebaseAuth = getAuth(firebaseApp);

  static firebaseAnalytics = getAnalytics(firebaseApp);
}
